import React from "react";
import { Row, Col, Container } from "react-bootstrap";
// import CustomCard from '../CustomCard';
import Card from "../Card";

import Pen from "../../../assets/images/PersonalizedGifts/Pen.jpg";
import Diary from "../../../assets/images/PersonalizedGifts/Diary.jpg";
import Rakhi from "../../../assets/images/PersonalizedGifts/Rakhi.jpg";
import KeyChain from "../../../assets/images/PersonalizedGifts/KeyChain.jpg";
import Statue from "../../../assets/images/PersonalizedGifts/Statue.jpg";
import PhotoFrame from "../../../assets/images/PersonalizedGifts/PhotoFrame.jpg";
import Mugs from "../../../assets/images/PersonalizedGifts/Mugs.jpg";

// Card Data
const cardData = [
  { image: Diary, text: "New Year Diaries" },
  { image: KeyChain, text: "Peronalized Keychains" },
  { image: Pen, text: "Custom text Pens" },
  { image: Rakhi, text: "Rakhi" },
  { image: Statue, text: "Custom Spiritual Art" },
  { image: PhotoFrame, text: "Customised Acrylic Frames" },
  { image: Mugs, text: "Mugs" },
];

function HomeSction4() {
  return (
    <>
      <Container>
        <h2 className="py-4 fw-bold text-center">Personalized Section</h2>
        {/* 1st row */}
        <Row>
          {cardData.slice(0, 2).map((card, index) => (
            <Col md={6} className="d-flex" key={index}>
              <Card image={card.image} text={card.text} />
            </Col>
          ))}
        </Row>

        {/* 2nd row */}
        <Row>
          {cardData.slice(2, 8).map((card, index) => (
            <Col md={4} className="d-flex" key={index}>
              <Card image={card.image} text={card.text} />
            </Col>
          ))}
        </Row>

        {/* Divider-line */}
        <hr className="divider-line" style={{ margin: "0 auto" }} />
      </Container>
    </>
  );
}

export default HomeSction4;
